import React, { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { logImpressionForSearch } from './requests';
import { useSearchRetrievalContext } from './RetrievalContextProviders';

interface EventTrackerProps {
    id: string | undefined;
    gaCategory: string | undefined;
    position?: number;
}

function isSearch(gaCategory: string | undefined) {
    return gaCategory === 'search';
}

const EventClickTrackerContext = React.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    eventClickTracker: () => {},
});

export function useEventClickTracker() {
    const searchRetrievalContext = useContext(EventClickTrackerContext);

    return searchRetrievalContext;
}

export function EventTracker(props: EventTrackerProps) {
    const { retrievalContext, shouldUseSDK } = useSearchRetrievalContext();
    const { ref, inView } = useInView({
        triggerOnce: true,
        fallbackInView: true,
        // Do not create intersection observer if FF off
        skip: !shouldUseSDK,
    });

    useEffect(() => {
        if (!shouldUseSDK) return;
        if (!props.id) return;

        if (inView && isSearch(props.gaCategory)) {
            // Don't log if no position; isn't expected
            if (props.position) {
                logImpressionForSearch(
                    props.id,
                    props.position,
                    retrievalContext,
                );
            }
        }
    }, [
        inView,
        props.id,
        props.gaCategory,
        props.position,
        retrievalContext,
        shouldUseSDK,
    ]);

    if (!shouldUseSDK) return null;

    return <span ref={ref}></span>;
}
